// format.ts — мелкие чистые форматтеры для экранов. Даты считаем из YMD-частей
// (UTC), чтобы не словить сдвиг локального часового пояса браузера: бэкенд уже
// отдаёт «локальную для tenant» дату строкой, переинтерпретировать её нельзя.

const MONTHS = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];
const WEEKDAYS = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];

/** Инициалы для аватара: «Анна Ковалёва» → «АК». */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  const value = (parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '');
  return value.toUpperCase() || '—';
}

/** YMD «2026-06-05» → «5 июня 2026». */
export function humanDate(ymd: string): string {
  const [y, m, d] = ymd.split('-').map(Number);
  if (!y || !m || !d) return ymd;
  return `${d} ${MONTHS[m - 1]} ${y}`;
}

/** YMD → заголовок колонки недели «Пт 5». */
export function dayHeader(ymd: string): string {
  const [y, m, d] = ymd.split('-').map(Number);
  if (!y || !m || !d) return ymd;
  const date = new Date(Date.UTC(y, m - 1, d));
  return `${WEEKDAYS[date.getUTCDay()]} ${d}`;
}

/** ISO-таймстамп → «18:21» (локальное время браузера) или ''. */
export function hhmm(iso: string | null): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
}
